import { gql } from 'graphql-tag'

/**
 * Mutation to authenticate a user with email and password
 */
export const LOGIN_MUTATION = gql`
  mutation Login($email: String!, $password: String!) {
    authenticateUserWithPassword(email: $email, password: $password) {
      ... on UserAuthenticationWithPasswordSuccess {
        sessionToken
        item {
          id
          name
          email
          phoneNumber
          role
          shortName
          label
          color
          companies { id name shortName navBarTitle active }
          leadAgencies { id name shortName active }
        }
      }
      ... on UserAuthenticationWithPasswordFailure {
        message
      }
    }
  }
`

/**
 * Mutation to end the current session (logout)
 */
export const LOGOUT_MUTATION = gql`
  mutation EndSession {
    endSession
  }
`
